// extracted by mini-css-extract-plugin
module.exports = {"extraInfo":"MonsterExtraInfo_extraInfo__1RcgM","savingThrows":"MonsterExtraInfo_savingThrows__N9BOR","bold":"MonsterExtraInfo_bold__2xwVc"};